import React from "react";
import { FullScreenModal } from "components/FullScreenModal";
import { useDispatch, useSelector } from "hooks";
import { Search } from "components/layout/Search";
import { setModal } from "utilities/UI/uiSlice";
import { Clamp } from "components/Clamp";
import { Caret } from "components/Caret";

import * as styles from "./Search.module.scss";

const CloseButton = () => {
  const dispatch = useDispatch();

  return (
    <Clamp
      onClick={() => dispatch(setModal(null))}
      className={styles.closeButton}
    >
      <Caret variant={"left"} />
    </Clamp>
  );
};

const SearchDialog = () => {
  const isOpen = useSelector((state) => state.utilities.ui.modal === "search");
  const dispatch = useDispatch();

  return (
    <FullScreenModal
      className={styles.modal}
      contentClassName={styles.dialog}
      hideHeader
      isOpen={isOpen}
      onClose={() => dispatch(setModal(null))}
    >
      <Search />
      <CloseButton />
    </FullScreenModal>
  );
};

export { SearchDialog };
